module.exports = "module.exports = __webpack_public_path__ + &quot;media/images/icon/icon-map-2b8eaca08672b7f38828cdd9f58d6476.svg&quot;;"